export const ORDER_TYPE = {
  ASCENDING: 'asc',
  DESCENDING: 'desc',
};
